export default __webpack_public_path__ + "static/media/phone2.ae778e44.svg";